/*global logger, showFcPaymentSuccessful, showWaitingApproval, showReviewModal, showBookingModified, myModal, myCookie, analyticEventTracker */

var pp = {
    showConfirmationSurvey: $('#showConfirmationSurvey').length > 0,
    showLocalisationSurvey: $('.localisation-survey').length > 0,
    init: function() {
        pp.action();
        pp.totalToggle();

        if ($('.extend-block').length > 0) {
            pp.expandInstructions();
        }
    },
    action: function() {
        $(document).ready(function() {
            const startTime = myCookie.getCookie('dch_pplsw');

            if (startTime === '') {
                return;
            }

            const postData = {
                eventName: 'Payment_PageLoaded',
                attributes: {
                    'attributeFullLoadTime': ((new Date().getTime() - parseInt(startTime)) / 1000).toFixed(2)
                }
            };

            analyticEventTracker.trackEvent(postData);
            myCookie.setCookie('dch_pplsw', '', 1);
        });

        $('.choose-payment-method').on('click', function(e) {
            e.preventDefault();

            var that = $(this),
                block = that.attr('href');

            if (that.hasClass('disabled') || that.hasClass('preload')) {
                return false;
            }

            $('.choose-payment-method, .payments-methods, .payment-tab').removeClass('active');

            that.addClass('active').find('.payments-methods').addClass('active');
            $(block).addClass('active');

            if (typeof payment !== 'undefined') {
                var eventData = '';
                switch (that.attr('href')) {
                    case '#payment-pp':
                        eventData = 'Paypal';
                        break;
                    case '#payment-gp':
                        eventData = 'Google pay';
                        break;
                    case '#payment-ap':
                        eventData = 'Apple pay';
                        break;
                    case '#payment-cc':
                    default:
                        eventData = 'Credit card';
                        break;
                }

                logger.setEventName('Switch to payment ' + eventData + ' tab');
                logger.setEventResult(true);
                logger.logEvent();
            }

        });

        if (typeof showWaitingApproval !== 'undefined' || typeof showReviewModal !== 'undefined') {

            if (typeof showBookingModified !== 'undefined' && showBookingModified) {
                let modalLayout = 'modifySuccessModal';
                let modalLayoutOptions = {closeOutside: true, noBorder: true, noHeader: true};
                myModal.staticModal(modalLayout, modalLayoutOptions);
            } else {
                pp.confirmationActions();

                $(document).on('click', '.review-event', function() {
                    myCookie.setCookie('review-' + btoa(_d.rn), 'clicked', 180);
                });
            }
        }

        if (typeof showFcPaymentSuccessful !== 'undefined' && showFcPaymentSuccessful) {
            myModal.staticModal('fcPaymentSuccessfulModal');

            try {
                dataLayer.push({
                    'event': 'fcPurchased'
                });
            } catch (err) {}
        }

        $('a.show-summary').on('click', function(e) {
           e.preventDefault();

           $(this).hide();
           $(this).next('.summary').css('display', 'flex');
        });

        $('a.show-price-details').on('click', function(e) {
           e.preventDefault();

           $(this).hide();
           $('.price-details-block').css('display', 'flex');
        });
    },
    confirmationActions: function() {
        if (showWaitingApproval) {
            setTimeout(function() {
                myModal.staticModal('awaitingApprovalModal');
            }, 2000);

            if (showReviewModal && !pp.showLocalisationSurvey) {
                $(document).on('click', '#closeAwaitingApproval', function(e) {
                    e.preventDefault();
                    pp.rateUs();
                });
            }
        } else if (showReviewModal && !pp.showLocalisationSurvey) {
            pp.rateUs();
        }
    },
    rateUs: function() {
        if (myCookie.getCookie('review-' + btoa(_d.rn))) {
            return;
        }

        setTimeout(function() {
            if (pp.showConfirmationSurvey) {
                myModal.staticModal('rateUsModal', { noHeader: true, onlyClose: true, closeOutside: true, modalBodyClass: 'h-680' });
            } else {
                myModal.staticModal('rateUsModal', { noHeader: true, onlyClose: true, gtmEvent: 'rateUsClose', closeOutside: true });
                dataLayer.push({
                    'event': 'rateUsImpression'
                });
            }
        }, 7000);
    },
    totalToggle: function() {
        $('.total-toggle').on('click', function() {
            $('#price-summary').stop().slideToggle();
            $('#total-toggle').toggleClass('opened');
        });
    },
    expandInstructions: function() {
        $('.toggle-instructions').on('click', function(e) {
            e.preventDefault();
            var that = $(this),
                more = that.data('more-text'),
                less = that.data('less-text'),
                mode = that.data('mode');

            $('[data-' + mode + '-hide], [data-' + mode + '-show]').toggle();

            that.text((that.hasClass('less') ? more : less)).toggleClass('less');
        });
    },
    checkPriceChanges: function() {

        return new Promise(function(resolve) {

            const checkPriceUrl = _d.url.reservation.checkPriceChanges.replace('number', $('#reservationNumber').val())
                .replace('email', $('#email').val()).replace('guid', $('#offerId').val());

            $.ajax({url: checkPriceUrl, dataType: 'json'})
                .done(function(response) {
                    if (typeof response.data !== 'undefined' && response.data !== null && typeof response.data.newCarId !== 'undefined') {
                        $('#offerId').val(response.data.newCarId);
                    }

                    if (typeof response.message.recheck !== 'undefined') {
                        myModal.staticModal(response.message.recheckType + 'Modal', {
                            msg: response.message.recheck
                        });
                        dataLayer.push({
                            'event': 'priceChangesImpression',
                            'priceChangesAction': response.message.recheckEventAction
                        });

                        resolve({
                            type: response.message.recheckType,
                            changesAction: response.message.recheckEventAction
                        });

                    } else if (typeof response.message.somethingWentWrong !== 'undefined') {
                        myModal.staticModal('somethingWentWrongModal');

                        resolve({
                            type: 'somethingWentWrongModal'
                        });
                    } else {
                        resolve(true);
                    }
                }).fail(function() {
                _d.jsWarning('Failed check price request');
                resolve(true);
            });
        });
    }
};
